/* EP A/B panier-bienvenue (22-10-2026) - welkomstkorting -10 % in het mandje. Alleen FR, alleen bezoekers zonder eerdere order.
   Toewijzing staat in <head> (layout/theme.liquid): window.EP_AB['panier-bienvenue'] = 'control' | 'test'.
   Blootstelling (beide varianten): eerste keer per sessie dat het mandje opent met >= 1 artikel -> ep_ab_exposure.
   Variant test, 1 stuk: blok "Offre de bienvenue" (e-mail + vrijwillig nieuwsbriefvinkje). Na "Appliquer":
     - BIENVENUE10 via /cart/update.js (niet stapelbaar met -15/-25 %, daarom alleen bij 1 stuk);
     - mandje bewaard via /apps/herroepen/panier (App Proxy -> e-mailengine: mandjesmail als ze niet afrekent);
     - nieuwsbrief alleen met vinkje, via hetzelfde klantformulier als de popup;
     - "Valider ma commande" gaat via een cart-permalink met het e-mailadres vooringevuld (cart-attributen gaan mee).
   Variant test, 2+ stuks: geen formulier; had ze de code al, dan een uitlegregel (de staffel gaat voor).
   Controle: alleen de blootstelling, verder niets. */
(function () {
  'use strict';
  var TEST = 'panier-bienvenue', CODE = 'BIENVENUE10', LS = 'ep_pb_v1';
  var v = (window.EP_AB || {})[TEST];
  if (v !== 'test' && v !== 'control') return;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var lastCart = null;

  function lees() { try { return JSON.parse(localStorage.getItem(LS)) || {}; } catch (e) { return {}; } }
  function bewaar(o) { try { localStorage.setItem(LS, JSON.stringify(o)); } catch (e) {} }
  function eur(c) { return ((c || 0) / 100).toFixed(2).replace('.', ',') + ' €'; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function ph(cb) {
    var n = 0;
    (function go() {
      var p = window.posthog;
      if (p && p.__loaded) { try { cb(p); } catch (e) {} return; }
      if (++n < 50) setTimeout(go, 200);
    })();
  }
  function haalCart() {
    return fetch(ROOT + 'cart.js?_t=' + Date.now(), { cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); });
  }
  function testLabel() {
    return (window.EP_TESTS || []).map(function (k) {
      var x = (window.EP_AB || {})[k];
      return x ? k + ':' + x : null;
    }).filter(Boolean).join(',');
  }
  function klaar(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---- Blootstelling: 1x per sessie, bij openen van het mandje met >= 1 artikel ---- */
  function blootstelling() {
    try { if (sessionStorage.getItem('ep_pb_exp') === '1') return; } catch (e) {}
    haalCart().then(function (c) {
      lastCart = c;
      if (!c || !c.item_count) return;
      try {
        if (sessionStorage.getItem('ep_pb_exp') === '1') return;
        sessionStorage.setItem('ep_pb_exp', '1');
      } catch (e) {}
      ph(function (p) {
        var sp = {}; sp['ab_' + TEST] = v;
        p.register(sp);
        p.capture('ep_ab_exposure', { test: TEST, variant: v, items: c.item_count });
      });
      if (v === 'test') teken(c);
    }).catch(function () {});
  }
  function volgLade() {
    var d = document.getElementById('CartDrawer');
    if (!d) return;
    var open = d.classList.contains('drawer--is-open');
    if (open) blootstelling();
    new MutationObserver(function () {
      var nu = d.classList.contains('drawer--is-open');
      if (nu && !open) blootstelling();
      open = nu;
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  }

  if (v !== 'test') { klaar(volgLade); return; }

  /* ---- Variant test ---- */
  var CSS = '' +
    '#CartDrawer .pb-host{padding:0 20px 16px}' +
    '#CartDrawer .pb-box{position:relative;margin-top:14px;padding:14px 16px 12px;background:#fff;border:1px solid #D9CFC3;border-left:3px solid #B87351;font-family:"Inter",-apple-system,system-ui,sans-serif;color:#1A1614;text-align:left}' +
    '#CartDrawer .pb-eyebrow{margin:0;font-family:"JetBrains Mono",ui-monospace,monospace;font-size:12px;letter-spacing:.14em;text-transform:uppercase;color:#8F5236}' +
    '#CartDrawer .pb-title{margin:4px 0;font-family:"Cormorant Garamond",Georgia,serif;font-size:25px;font-weight:500;line-height:1.1;color:#1A1614}' +
    '#CartDrawer .pb-text{margin:0 0 10px;font-size:15px;line-height:1.4;color:#3A2F28}' +
    '#CartDrawer .pb-label{display:block;margin:0 0 4px;font-size:13px;color:#6B6058}' +
    '#CartDrawer .pb-row{display:flex;gap:8px}' +
    '#CartDrawer .pb-input{flex:1;min-width:0;height:48px;box-sizing:border-box;margin:0;padding:0 12px;border:1px solid #8F8577;border-radius:0;background:#fff;color:#1A1614;font-family:"Inter",-apple-system,system-ui,sans-serif;font-size:16px;-webkit-appearance:none;appearance:none;box-shadow:none}' +
    '#CartDrawer .pb-input::placeholder{color:#7A6F66}' +
    '#CartDrawer .pb-input[aria-invalid=true]{border-color:#9B2C1F}' +
    '#CartDrawer .pb-btn{flex-shrink:0;height:48px;margin:0;padding:0 14px;background:#fff;color:#1A1614;border:1px solid #1A1614;border-radius:0;font-family:"JetBrains Mono",ui-monospace,monospace;font-size:13px;font-weight:500;letter-spacing:.1em;text-transform:uppercase;cursor:pointer}' +
    '#CartDrawer .pb-btn:disabled{opacity:.6;cursor:default}' +
    '#CartDrawer .pb-err{margin:6px 0 0;font-size:13px;font-weight:500;color:#9B2C1F}' +
    '#CartDrawer .pb-optin{display:flex;align-items:center;gap:10px;min-height:44px;margin:6px 0 0;font-size:13px;line-height:1.35;color:#3A2F28;cursor:pointer}' +
    '#CartDrawer .pb-optin input{flex-shrink:0;width:20px;height:20px;margin:0;accent-color:#1A1614}' +
    '#CartDrawer .pb-small{margin:2px 0 0;font-size:12.5px;color:#6B6058}' +
    /* het thema maakt <label> mono + hoofdletters: hier gewone tekst */
    '#CartDrawer .pb-label,#CartDrawer .pb-optin,#CartDrawer .pb-optin span{font-family:"Inter",-apple-system,system-ui,sans-serif!important;text-transform:none!important;letter-spacing:normal!important;font-weight:400!important}' +
    /* Cormorant toont standaard mediaevale cijfers ("-10" leek op "-io") */
    '#CartDrawer .pb-title,#CartDrawer .pb-ok-amt{font-variant-numeric:lining-nums;font-feature-settings:"lnum" 1}' +
    '#CartDrawer .pb-hp{position:absolute;left:-9999px;width:1px;height:1px;opacity:0}' +
    '#CartDrawer .pb-ok{display:flex;justify-content:space-between;align-items:center;gap:12px;margin-top:14px;padding:12px 14px;background:#F2E0D5;border-left:3px solid #B87351}' +
    '#CartDrawer .pb-ok-l{display:flex;flex-direction:column;gap:2px}' +
    '#CartDrawer .pb-ok-lab{font-family:"JetBrains Mono",ui-monospace,monospace;font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:#8F5236}' +
    '#CartDrawer .pb-ok-name{font-size:14px;font-weight:500;color:#3A2F28}' +
    '#CartDrawer .pb-ok-amt{font-family:"Cormorant Garamond",Georgia,serif;font-size:21px;font-weight:600;color:#8F5236;white-space:nowrap}' +
    '#CartDrawer .pb-note,#CartDrawer .pb-info{display:flex;align-items:flex-start;gap:8px;margin:12px 0 0;font-size:14px;line-height:1.45;color:#3A2F28}' +
    '#CartDrawer .pb-info{margin-top:14px;padding:12px 14px;background:#fff;border:1px solid #D9CFC3}' +
    '#CartDrawer .pb-note svg,#CartDrawer .pb-info svg{flex-shrink:0;margin-top:2px}' +
    '#CartDrawer .pb-note strong,#CartDrawer .pb-info strong{font-weight:600;color:#1A1614}' +
    '#CartDrawer .pb-prefill{margin:6px 0 0;text-align:center;font-size:12.5px;color:#6B6058}';

  var VINK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5A8F6A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L20 7"></path></svg>';
  var INFO = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8F5236" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M12 11v6M12 7.5v.5"></path></svg>';

  function stijl() {
    if (document.getElementById('pb-css')) return;
    var s = document.createElement('style');
    s.id = 'pb-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }
  function host() {
    var d = document.getElementById('CartDrawer');
    if (!d) return null;
    var h = d.querySelector('.pb-host');
    if (h) return h;
    var prod = d.querySelector('[data-products]');
    if (!prod || !prod.parentNode) return null;
    h = document.createElement('div');
    h.className = 'pb-host';
    prod.parentNode.insertBefore(h, prod.nextSibling);
    return h;
  }
  function codeOp(c) {
    var x = (c.discount_codes || []).filter(function (d) { return String(d.code || '').toUpperCase() === CODE; })[0];
    return x ? { aan: true, geldig: !!x.applicable } : { aan: false, geldig: false };
  }
  function bedrag(c) {
    var a = (c.cart_level_discount_applications || []).filter(function (d) {
      return String(d.title || '').toUpperCase() === CODE;
    })[0];
    var n = a ? parseInt(a.total_allocated_amount, 10) : NaN;
    return isNaN(n) ? (parseInt(c.total_discount, 10) || 0) : n;
  }

  function formulier(st) {
    return '<div class="pb-box" role="group" aria-labelledby="pb-titre">' +
      '<p class="pb-eyebrow">Offre de bienvenue</p>' +
      '<p class="pb-title" id="pb-titre">−10 % sur cette commande</p>' +
      '<p class="pb-text">Appliqué tout de suite. Votre panier vous attend aussi par e-mail.</p>' +
      '<label class="pb-label" for="pb-email">Adresse e-mail</label>' +
      '<div class="pb-row">' +
        '<input class="pb-input" id="pb-email" type="email" inputmode="email" autocomplete="email" autocapitalize="off" spellcheck="false" placeholder="votre@email.fr" value="' + esc(st.email || '') + '">' +
        '<button type="button" class="pb-btn" data-pb-apply>Appliquer</button>' +
      '</div>' +
      '<p class="pb-err" role="status" hidden>Saisissez une adresse e-mail valide.</p>' +
      '<label class="pb-optin"><input type="checkbox" id="pb-optin"><span>Recevoir aussi nos nouveautés et offres (désinscription en un clic)</span></label>' +
      '<p class="pb-small">1re commande · non cumulable avec −15 % / −25 %</p>' +
      '<input type="text" class="pb-hp" tabindex="-1" autocomplete="off" aria-hidden="true">' +
    '</div>';
  }
  function bevestiging(st, c) {
    return '<div class="pb-ok">' +
      '<div class="pb-ok-l"><span class="pb-ok-lab">Offre de bienvenue</span>' +
      '<span class="pb-ok-name">' + CODE + ' · −10 % appliqué</span></div>' +
      '<span class="pb-ok-amt">−' + eur(bedrag(c)) + '</span>' +
    '</div>' +
    '<p class="pb-note">' + VINK + '<span>Panier enregistré pour <strong>' + esc(st.email) + '</strong>. Il vous attend par e-mail si vous finalisez plus tard.</span></p>';
  }
  function uitleg(c) {
    var pct = c.item_count >= 3 ? 25 : 15;
    return '<p class="pb-info">' + INFO + '<span>Avec ' + c.item_count + ' articles, votre <strong>−' + pct +
      ' %</strong> est plus avantageux que l’offre de bienvenue (−10 %) : il est appliqué automatiquement.</span></p>';
  }

  var PROG = 'Ajoutez <strong>1 article</strong> : <strong>−15 %</strong> sur les deux au lieu de −10 % · Livraison offerte';
  var wens = null, bewaakt = false, PROG_TXT = null;
  function handhaaf() {
    var d = document.getElementById('CartDrawer');
    if (!d || !wens) return;
    if (PROG_TXT === null) { var tmp = document.createElement('div'); tmp.innerHTML = PROG; PROG_TXT = tmp.textContent; }
    var sub = d.querySelector('[data-subtotal]'), pt = d.querySelector('[data-progress-text]');
    // vergelijken op textContent (innerHTML zou &nbsp; teruggeven en nooit gelijk zijn -> lus)
    if (wens.sub && sub && sub.textContent !== wens.sub) sub.textContent = wens.sub;
    if (pt && pt.textContent !== PROG_TXT) pt.innerHTML = PROG;
    if (!bewaakt) {
      bewaakt = true;
      var mo = new MutationObserver(function () { if (wens) handhaaf(); });
      [sub, pt].forEach(function (el) { if (el) mo.observe(el, { childList: true, characterData: true, subtree: true }); });
    }
  }

  function teken(c) {
    if (!c) return;
    lastCart = c;
    stijl();
    var h = host();
    if (!h) return;
    var st = lees(), code = codeOp(c), n = c.item_count || 0;
    var html = '', sleutel = 'leeg';
    if (n === 1 && st.email && code.aan && code.geldig) { html = bevestiging(st, c); sleutel = 'ok|' + st.email + '|' + bedrag(c); }
    else if (n === 1) { html = formulier(st); sleutel = 'form|' + (st.email || ''); }
    else if (n >= 2 && (st.email || code.aan)) { html = uitleg(c); sleutel = 'info|' + n; }
    // alleen hertekenen als de toestand verandert (een half ingetikt e-mailadres blijft staan)
    if (h.getAttribute('data-staat') !== sleutel) {
      h.innerHTML = html;
      h.setAttribute('data-staat', sleutel);
    }
    var d = document.getElementById('CartDrawer');
    if (!d) return;
    // Bij een toegepaste welkomstcode: subtotaal = voor korting (anders lijkt de korting 2x afgetrokken)
    // en de voortgangstekst eerlijk maken (een 2e stuk geeft -15 % op beide in plaats van -10 %).
    // Andere thema-scripts schrijven die twee velden later opnieuw, dus houdt handhaaf() ze vast zolang dit geldt.
    if (n === 1 && code.aan && code.geldig) {
      wens = { sub: c.original_total_price ? eur(c.original_total_price) : null, prog: PROG };
    } else {
      wens = null;
    }
    handhaaf();
    // "Votre e-mail est déjà rempli au paiement" onder de knop zodra we het adres hebben
    var cta = d.querySelector('.ep-cart-cta'), noot = d.querySelector('.pb-prefill');
    if (st.email && n > 0 && cta) {
      if (!noot) {
        noot = document.createElement('p');
        noot.className = 'pb-prefill';
        noot.textContent = 'Votre e-mail est déjà rempli au paiement.';
        cta.parentNode.insertBefore(noot, cta.nextSibling);
      }
    } else if (noot) {
      noot.parentNode.removeChild(noot);
    }
  }

  function toepassen() {
    var d = document.getElementById('CartDrawer');
    if (!d) return;
    var inp = d.querySelector('#pb-email'), cb = d.querySelector('#pb-optin'), btn = d.querySelector('[data-pb-apply]');
    var err = d.querySelector('.pb-err'), hp = d.querySelector('.pb-hp');
    if (!inp || !btn) return;
    var email = (inp.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)) {
      if (err) err.hidden = false;
      inp.setAttribute('aria-invalid', 'true');
      inp.focus();
      return;
    }
    if (err) err.hidden = true;
    inp.removeAttribute('aria-invalid');
    btn.disabled = true;
    btn.textContent = '…';
    var optin = !!(cb && cb.checked), c = lastCart || { items: [], item_count: 0 };
    bewaar({ email: email, optin: optin, t: Date.now() });
    // de popup biedt hetzelfde aanbod: niet meer tonen
    try {
      var s = JSON.parse(localStorage.getItem('ep_signup_v1')) || {};
      s.done = true;
      localStorage.setItem('ep_signup_v1', JSON.stringify(s));
    } catch (e) {}
    if (optin) nieuwsbrief(email);
    fetch('/apps/herroepen/panier', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        email: email, optin: optin, hp: hp ? hp.value : '',
        lines: (c.items || []).map(function (i) { return { variant_id: i.variant_id, quantity: i.quantity }; }),
        title: (c.items && c.items[0]) ? c.items[0].product_title : '',
        total: ((c.total_price || 0) / 100).toFixed(2),
        ph_test: testLabel()
      })
    }).catch(function () {});
    ph(function (p) { p.capture('pb_email_submitted', { optin: optin, items: c.item_count || 0 }); });
    fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ discount: CODE })
    }).then(function (r) { return r.json(); })
      .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh')); })
      .catch(function () { document.dispatchEvent(new CustomEvent('cart:refresh')); });
  }

  // Nieuwsbrief-opt-in (22-10-2026): fetch('/contact') kreeg 403 van Shopify's hCaptcha en schreef niemand in.
  // Nu een echt (verborgen) klantformulier dat Shopify.captcha beveiligt; antwoord in een verborgen frame,
  // de bezoeker blijft gewoon in het mandje. Zelfde aanpak als de popup in V23.
  var nbBezig = false;
  function nieuwsbrief(email) {
    if (nbBezig) return;
    nbBezig = true;
    var buiten = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;overflow:hidden;border:0';
    var fr = document.createElement('iframe');
    fr.name = 'pb-nb-frame';
    fr.setAttribute('sandbox', 'allow-same-origin');
    fr.setAttribute('aria-hidden', 'true');
    fr.tabIndex = -1;
    fr.style.cssText = buiten;
    var f = document.createElement('form');
    f.method = 'post';
    f.action = ROOT + 'contact#pb';
    f.acceptCharset = 'UTF-8';
    f.target = 'pb-nb-frame';
    f.style.cssText = buiten;
    [['form_type', 'customer'], ['utf8', '✓'], ['contact[tags]', 'newsletter,popup,panier'], ['contact[email]', email]].forEach(function (kv) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = kv[0]; i.value = kv[1];
      f.appendChild(i);
    });
    document.body.appendChild(fr);
    document.body.appendChild(f);
    var verzonden = false;
    fr.addEventListener('load', function () {
      if (!verzonden) return;
      var pad = '';
      try { pad = fr.contentWindow.location.pathname + (/customer_posted=true/.test(fr.contentWindow.location.search) ? '?customer_posted' : ''); } catch (x) { pad = 'onleesbaar'; }
      ph(function (p) { p.capture('pb_newsletter_posted', { via: pad }); });
    });
    try { if (window.Shopify && Shopify.captcha && Shopify.captcha.protect) Shopify.captcha.protect(f); } catch (e) {}
    var n = 0;
    (function wacht() {
      var klaar = !(window.Shopify && Shopify.captcha) || f.hasAttribute('data-hcaptcha-bound');
      if (klaar || ++n > 60) { verzonden = true; f.submit(); } else { setTimeout(wacht, 100); }
    })();
  }

  function permalink(c, email) {
    var q = [];
    if (c.item_count === 1) q.push('discount=' + CODE);
    var a = c.attributes || {};
    Object.keys(a).forEach(function (k) {
      if (a[k] !== null && a[k] !== '') q.push('attributes%5B' + encodeURIComponent(k) + '%5D=' + encodeURIComponent(a[k]));
    });
    q.push('checkout%5Bemail%5D=' + encodeURIComponent(email));
    return ROOT + 'cart/' + (c.items || []).map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',') + '?' + q.join('&');
  }

  // Thema roept dit aan aan het eind van epSyncCart (na elke mandje-wijziging)
  window.epPbSync = function (c) { teken(c); };

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#CartDrawer [data-pb-apply]')) { e.preventDefault(); toepassen(); }
  });
  document.addEventListener('keydown', function (e) {
    // Enter in het e-mailveld mag het mandjesformulier (= naar de checkout) niet versturen
    if (e.key === 'Enter' && e.target && e.target.id === 'pb-email') { e.preventDefault(); toepassen(); }
  }, true);
  // "Valider ma commande": met bekend e-mailadres via een permalink naar de checkout (e-mail vooringevuld).
  // De checkout-meting (checkout_started_v2) vuurt al eerder in de capture-fase van theme.liquid.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.id !== 'CartDrawerForm') return;
    var st = lees(), c = lastCart;
    if (!st.email || !c || !c.item_count || !(c.items || []).length) return;
    var eigenschappen = (c.items || []).some(function (i) {
      var p = i.properties || {};
      return Object.keys(p).some(function (k) { return p[k] !== null && p[k] !== ''; });
    });
    if (eigenschappen) return; // permalinks kunnen geen regel-eigenschappen meenemen: gewone checkout
    e.preventDefault();
    window.location.href = permalink(c, st.email);
  });

  klaar(function () {
    volgLade();
    haalCart().then(function (c) { teken(c); }).catch(function () {});
  });
})();
